/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_TitleInputs */

const en_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Comparison`)
};

const ar_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقارنة الخطط`)
};

const de_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planvergleich`)
};

const es_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparación de planes`)
};

const fr_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparaison des plans`)
};

const it_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto dei piani`)
};

const ja_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランの比較`)
};

const ko_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랜 비교`)
};

const pt_br_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparação de Planos`)
};

const ru_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнение планов`)
};

const th_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปรียบเทียบแผน`)
};

const tr_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Karşılaştırması`)
};

const zh_cn_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`方案比较`)
};

const zh_tw_subscription_service_level_compare_title = /** @type {(inputs: Subscription_Service_Level_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`方案比較`)
};

/**
* | output |
* | --- |
* | "Plan Comparison" |
*
* @param {Subscription_Service_Level_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_title = /** @type {((inputs?: Subscription_Service_Level_Compare_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_title(inputs)
	return zh_tw_subscription_service_level_compare_title(inputs)
});